import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, OnInit, inject } from '@angular/core';
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { DownPaymentType } from '@app/shared/enums/down-payment-type.enum';
import { PaymentType } from '@app/shared/enums/payment-type.enum';
import { ITreatmentApiModel } from '@app/shared/models';
import { BookingStepsFormType } from '@app/shared/models/booking-steps-form-type.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-choose-payment-method',
  templateUrl: './choose-payment-method.component.html',
  styleUrls: ['./choose-payment-method.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TranslateModule, ReactiveFormsModule],
  viewProviders: [{
    provide: ControlContainer,
    useExisting: FormGroupDirective
  }]
})
export class BookingPartChoosePaymentMethodComponent implements OnInit {

  public parentForm: BookingStepsFormType | null;
  public readonly parentFormDirective = inject(FormGroupDirective);

  public paymentMethod: PaymentType;
  public PaymentType = PaymentType;

  public areFullPaymentOnlineOrInSalonChoicesVisible: boolean;
  public isDownPaymentOnlineChoiceVisible: boolean;
  public areDownPaymentOnlineOrFullPaymentOnlineChoicesVisible: boolean;
  public isEveryTreatmentAvailableForOnlinePayment: boolean;
  public hasTreatmentWithMandatoryPayment: boolean;

  public downPaymentRequiredAmount = 0;

  ngOnInit(): void {
    this.parentForm = this.parentFormDirective.form;
    this.isEveryTreatmentAvailableForOnlinePayment = this.treatments.every(item =>
      item.isPriceVisibleForOnlineBooking === true);
    this.hasTreatmentWithMandatoryPayment = this.treatments.some(item =>
      item.mandatoryDownPayment === DownPaymentType.DownPaymentOnly ||
      item.mandatoryDownPayment === DownPaymentType.DownPaymentAndFullPrice);
    this.paymentMethod = this.pickDefaultPaymentMethod();
    this.setupPaymentMethodsVisibility();
  }

  public selectPaymentMethod(paymentMethod: PaymentType): void {
    this.paymentMethod = paymentMethod;
    this.parentForm.controls.paymentType.setValue(paymentMethod);
  }

  private get treatments(): ITreatmentApiModel[] {
    return this.parentForm.controls.treatmentAssingments.controls.map(treatmentAssingment => (treatmentAssingment.controls.treatment.value));
  }

  private pickDefaultPaymentMethod(): PaymentType {
    let paymentMethod = this.parentForm.controls.paymentType.value;
    if (this.hasTreatmentWithMandatoryPayment) {
      paymentMethod = PaymentType.DownPaymentOnline;
      this.parentForm.controls.paymentType.setValue(paymentMethod);
    } else if (this.isEveryTreatmentAvailableForOnlinePayment) {
      paymentMethod = PaymentType.Online;
      this.parentForm.controls.paymentType.setValue(paymentMethod);
    }
    return paymentMethod;
  }

  private setupPaymentMethodsVisibility(): void {

    if (this.hasTreatmentWithMandatoryPayment) {
      const filteredItems = this.treatments.filter(y =>
        y.mandatoryDownPayment === DownPaymentType.DownPaymentAndFullPrice ||
        y.mandatoryDownPayment === DownPaymentType.DownPaymentOnly);
      this.downPaymentRequiredAmount = filteredItems.reduce((acc, curr) => acc + Number(curr.downPaymentRequiredAmount), 0);
      this.isDownPaymentOnlineChoiceVisible = true;
      if (this.isEveryTreatmentAvailableForOnlinePayment) {
        this.areDownPaymentOnlineOrFullPaymentOnlineChoicesVisible = true;
      }
    } else {
      this.areFullPaymentOnlineOrInSalonChoicesVisible = this.isEveryTreatmentAvailableForOnlinePayment;
    }
  }
}
